module.exports = __webpack_public_path__ + "img/picto-nbre-chambres.83769d1c.svg";